import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { InjectionToken } from '@angular/core';
import { Action, ActionTypes } from './actions';
import { desc } from '../../helpers/desc';
export { Action };

// tslint:disable-next-line: interface-over-type-literal
export type State = {
  data: any;
};

export const defaultState: State = {
  data: undefined,
};

export const selector = (state: State) => state.data;

export const selectData = createSelector(
  createFeatureSelector('FILTERABLE_TABLE'),
  selector,
);

export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<State>
>('Feature Reducers');

function sortData(state: State, payload: any) {
  const { key, direction } = payload;
  const { data } = state;
  const sortedData = data.sort(desc(key));
  if (direction === 'ASC') {
    return sortedData.reverse();
  }
  return sortedData;
}

export const reducer: ActionReducer<State, Action> = (
  state: State = defaultState,
  action: Action,
): State => {
  switch (action.type) {
    case ActionTypes.LoadData:
      return {
        ...state,
        data: action.payload,
      };
    case ActionTypes.SortData:
      return {
        ...state,
        data: sortData(state, action.payload),
      };

    default:
      return state;
  }
};

export default reducer;
